import request from '@/axios/http'

// 注册接口
export function register (data) {
	return request({
		url: '/stage-api/register',
		method: 'post',
		data
	})
}

// 发送邮箱验证码  (注册)
export function sendEmailCode (data) {
	return request({
		url: '/stage-api/email/sendEmailCode',
		method: 'post',
		data
	})
}

// 发送邮箱验证码  (重置密码)
export function findPassword (data) {
	return request({
		url: '/stage-api/email/findPassword',
		method: 'post',
		data
	})
}

// 忘记密码
export function resetPwd (data) {
	return request({
		url: '/stage-api/resetPwd',
		method: 'post',
		data
	})
}

// 登录
export function pwdLogin (data) {
	return request({
		url: '/stage-api/pwdLogin',
		method: 'post',
		data
	})
}







